/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../util/loadingLayer';
import formMessages from '../util/formMessages';
import createForm from '../util/createForm';

export default {
	init() {
		formMessages().useCaptcha();
		const $form = $('#renew-form');
		const url = $form.attr('action-ajax') || $form.attr('action');
		const method = $form.attr('method');
		const data = {};

		$('.membership-type', $form).on('change', function () {
			const price = $(this).data('price');
			$('#package_price', $form).text(price + '.00');
		});

		formMessages($form).validate();

		$("#btn-eway-payment").on("click", function () {
			eCrypt.showModalPayment(eWAYConfig, function (result, transactionID, errors) {
				if (result == "Complete") {
					// Donate
					$.ajax({
						url,
						method: 'post',
						data: {
							...data,
							nonce: window.meta_object.nonce,
							captcha_token: window.meta_object.captcha_token,
							action: 'member-renew',
						},
						dataType: 'json'
					}).always(() => {
						formMessages().reloadCaptcha();
					}).done((result) => {
						if (result.success) {
							if (result.successUrl) {
								window.location.replace(result.successUrl);
								loadingLayer.hideLoading();
								return;
							}
						}
					}).fail((err) => {
						loadingLayer.hideLoading();
						console.log(err);
					});
				} else if (result == "Error") {
					formMessages($form, {
						success: false,
						message: 'Please check your credit/debit card information and try again.',
					}).run();
				}
			});
		});

		$form.on('submit', function (event) {
			event.stopImmediatePropagation();
			event.preventDefault();

			loadingLayer.showLoading();
			formMessages($form).init();

			const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();

			for (var i in formData) {
				data[formData[i].name] = formData[i].value;

				$('#' + formData[i].name, $form).removeClass('is-invalid');
				$('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
			}

			$.ajax({
				url,
				method: 'post',
				data: {
					...data,
					nonce: window.meta_object.nonce,
					captcha_token: window.meta_object.captcha_token,
					action: 'eway-access-code-renew',
				},
				dataType: 'json'
			}).always(() => {
				formMessages().reloadCaptcha();
			}).fail(() => {
				loadingLayer.hideLoading();
			}).done((validateData) => {
				if (validateData && !validateData.success) {
					formMessages($form, validateData).run();
					loadingLayer.hideLoading();
					return;
				}

				if (validateData.data.ecrypt_btn) {
					$("#eway-ecrypt").html(validateData.data.ecrypt_btn);
					setTimeout(function () {
						$("#btn-eway-payment").click();
						loadingLayer.hideLoading();
					}, 500);
				}
			});
		});
	},
	finalize() {

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/memberRenew.js